"use strict";
/**
 * File-related type definitions
 */
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=file.js.map